import PropTypes from "prop-types";
import React from "react";
import {MSpinner} from "components/Shared";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";

function Stats(props) {
  return (
    <div className="stat-list">
      <span className="title">{props.title}</span>
      {props.items.map((stat, index) => {
          return (<div className="stat-item" key={index}>
            <span className="count">{stat.count}</span>
            <span className="name">{stat.name}</span>
          </div>);
        })}
      </div>
  );
}

Stats.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string
};

const Statistics = ({ isFetching, statistics, isAppraiserManager, isCustomerService }) => {
  if (isFetching) {
    return <MSpinner/>;
  }

  return (
    <Card className="md-cell md-cell--4">
      <CardTitle title={` ${isCustomerService ? "Customer Service Stats" : `Appraiser ${isAppraiserManager ? "Manager" : ""} Stats`}`} />
      <CardText>
        {isAppraiserManager
          ? <Stats items={statistics.managerStatus} />
          : <Stats items={statistics.appraiserStatus} />
        }
      </CardText>
    </Card>
  );
};

Statistics.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  statistics: PropTypes.object.isRequired,
  isAppraiserManager: PropTypes.bool.isRequired,
  isCustomerService: PropTypes.bool,
};

export default Statistics;